export const h1 = {}
export const h2 = {}
export const h3 = {}
export const h4 = {}
export const h5 = {}
export const h6 = {}
export const a = {}
export const ol = {}
export const ul = {}
export const li = {}
export const p = {}
export const document = {}
